import parse from 'date-fns/parse';
import isValid from 'date-fns/is_valid';
import format from 'date-fns/format';
import differenceInSeconds from 'date-fns/difference_in_seconds';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import { match, required } from '../../utils/validation';
import { formatMacAddress, normalizeMacAddress } from '../../utils/inputs';
import { POSITION_SOURCE, DEVICE_SUPER_TAG, SUPER_TAG } from '../../constants/data';
import { I18n } from 'react-redux-i18n';

export const TagFieldFormat = {
  id: value => formatMacAddress(value)
};

export const TagFieldNormalize = {
  id: value => normalizeMacAddress(value)
};

export const TagValidations = {
  name: required('models.tag.name'),
  id: [
    required('models.tag.macAddress'),
    match(
      /([0-9a-f]{2}:){4}[0-9a-f]{2}/i,
      'models.tag.id',
      'models.tag.idPlaceholder'
    )
  ],
  category: null,
  group: [],
  field1: [],
  field2: []
};

export const translateBattery = (status)=>{
  if(+status === 1){
    return I18n.t('data.batteryState.good')
  }else{
    return I18n.t('data.batteryState.bad')
  }
}

const MSG_SOURCE = {
  4: 'gps',
  5: 'wifi',
  6: 'cellid'
}


const TIME_SOURCE = {
  location: 'location',
  gps: 'gps'
}

class Serializer {

  whichTime = (at, bt)=>{
    let a = this.normalizeTimeValue(at);
    let b = this.normalizeTimeValue(bt);
    if(!a){
      return {source:'b', value: b};
    }
    if(!b){
      return {source: 'a', value: a};
    }
    if(a.time && !b.time){
      return {source: 'a', value: a}
    }
    if(b.time && !a.time){
      return {source: 'b', value: b}
    }
    if(a.time > b.time){
      return {source: 'a', value: a}
    }else{
      return {source: 'b', value: b}
    }
  }

  normalizeTime = data => {
    if(!data){
      return {};
    }

    let current = this.whichTime(data.locationTime, data.latitude_time);
    let lastEventTime = this.normalizeTimeValue(data.lastEventTime);

    return {
      isLocationTimeValid: current.value.isTimeValid,
      timeSource: current.source === 'a' ? TIME_SOURCE.location: TIME_SOURCE.gps,
      locationTime: current.value.time,
      locationTimeDiff: current.value.timeDiff,
      isLastEventTimeValid: lastEventTime.isTimeValid,
      lastEventTime: lastEventTime.time,
      lastEventTimeDiff: lastEventTime.timeDiff,
    };
  };
  normalizeTimeValue = value => {
    if(typeof(value) === 'string'){
      value = value.concat('Z'); //api does not return TZ, everything is in UTC
    }
    let time = parse(value || '');
    let isTimeValid = isValid(time);
    let differenceToNow = isTimeValid
      ? differenceInSeconds(time, Date.now())
      : 0;

    return {
      time: isTimeValid ? time : '',
      isTimeValid,
      timeDiff: Math.abs(differenceToNow)
    };
  };
  normalizeStream = event => {
    let eventTime = this.normalizeTimeValue(event.value.startReceiveTime);
    let battery = '';
    if('batteryPercentage' in event.metadata.props){
      battery =  +event.metadata.props.batteryPercentage
    }else if('batteryStatus' in event.metadata.props) {
      battery = translateBattery(event.metadata.props.batteryStatus)
    }
    let p = event.metadata.props;

    let d = {
      id: event.value.module,
      areaId: p.areaId || 'unknown',
      areaName: p.areaName,
      zone: {id: p.zoneId, name: p.zoneName},
      battery: battery,
      msgType: +p.msgType,
      lastSeen: format(eventTime.time, 'M / D / YY HH:mm'),
      time: {
        isLocationTimeValid: eventTime.isTimeValid,
        locationTime: eventTime.time,
        locationTimeDiff: eventTime.timeDiff,
        isLastEventTimeValid: eventTime.isTimeValid,
        lastEventTime: eventTime.time,
        lastEventTimeDiff: eventTime.timeDiff
      }
    };
    if(event.value.locations.length || (event.metadata.props.latitude && event.metadata.props.longitude)){
        d.location=  event.value.locations.length ? { macAddress: event.value.locations[0] } : {};
        d.locationName= event.metadata.props.locationName;
        d.latitude= +(event.metadata.props.latitude || 0);
        d.longitude= +(event.metadata.props.longitude || 0);
        d.source= event.metadata.props.positionSource || POSITION_SOURCE.GPS;
    }
    return d;
  };

  normalize = data => {
    let time = this.normalizeTime(data.assetInfo.metadata.props);
    let battery = '';
    if('batteryPercentage' in data.assetInfo.metadata.props){
      battery = +data.assetInfo.metadata.props.batteryPercentage;
    }else if('batteryStatus' in data.assetInfo.metadata.props){
      battery = translateBattery(data.assetInfo.metadata.props.batteryStatus)
    }
    let rt = data.registrationToken;
    if(rt === DEVICE_SUPER_TAG || rt === 'd29b3be8f2cc9a1a7051'){ //ANOTHER HACK for demo
      time.isLost = false;
      time.deviceType = SUPER_TAG; //HACK factor 10, temorary till islost is fixed
    }
    let l = {};
    let z = {};
    let isHelp = +(data.assetInfo.metadata.props.helpTag)===1 ? true : false;
    let mt = +data.assetInfo.metadata.props.lastMsgType;
    if(time.timeSource === TIME_SOURCE.location){
      if(isHelp && mt === 3){
        l = { macAddress: data.assetInfo.metadata.props.location0 }
        z = {
          id: data.assetInfo.metadata.props.zoneId,
          name: data.assetInfo.metadata.props.zoneName
        }
      }else if(!isHelp){
        l = { macAddress: data.assetInfo.metadata.props.location0 }
        z  = {
          id: data.assetInfo.metadata.props.zoneId,
          name: data.assetInfo.metadata.props.zoneName
        }
      }      
    }else{
      z  = {
        id: data.assetInfo.metadata.props.zoneId,
        name: data.assetInfo.metadata.props.zoneName
      }
    }
    let dt = (rt === DEVICE_SUPER_TAG || rt === 'd29b3be8f2cc9a1a7051') ? SUPER_TAG : 'other';
    return {
      id: data.nodeAddress,
      deviceType: dt,
      isSuperTag: dt === SUPER_TAG,
      href: data.self ? data.self.href : '',
      account: { id: data.assetInfo.metadata.props.accountId },
      site: { id: data.assetInfo.metadata.props.siteId },
      areaName: data.assetInfo.metadata.props.areaId ? data.assetInfo.metadata.props.areaName : I18n.t('unknown'),
      areaId: data.assetInfo.metadata.props.areaId,
      zone: z,
      zoneName: data.assetInfo.metadata.props.zoneName,
      helpTag: isHelp,
      msgType: mt,
      location: l,
      locationName: data.assetInfo.metadata.props.locationName,
      category: { id: data.assetInfo.metadata.props.categoryId },
      categoryName: data.assetInfo.metadata.props.categoryName || '',
      group: data.assetInfo.metadata.props.groupId_0 && {
        id: data.assetInfo.metadata.props.groupId_0
      },
      groupName: data.assetInfo.metadata.props.groupName || '',
      macAddress: data.assetInfo.metadata.props.macAddress,
      name: data.assetInfo.metadata.props.description,
      field1: data.assetInfo.metadata.props.field1,
      field2: data.assetInfo.metadata.props.field2,
      homeLocation: data.assetInfo.metadata.props.homeLocation,
      trackTagAge: data.assetInfo.metadata.props.trackTagAge,
      battery: battery,
      lastSeen: format(time.lastEventTime, 'M / D / YY HH:mm'),
      lastEventTime: time.lastEventTime,
      latitude:
        data.assetInfo.metadata.props.latitude &&
        +data.assetInfo.metadata.props.latitude,
      longitude:
        data.assetInfo.metadata.props.longitude &&
        +data.assetInfo.metadata.props.longitude,
      time,
      source: data.assetInfo.metadata.props.positionSource || POSITION_SOURCE.GPS,
      isLost: data.assetInfo.metadata.props.isLost !== 'false'
    };
  };
  normalizeBulkUpload = data => {
    return {
      recordCount: data.records,
      successCount: data.successCount,
      errorCount: data.errorCount,
      tags:
        data.results &&
        Object.values(data.results).map(tag => this.normalize(tag)),
      errors:
        data.errors &&
        sortBy(
          map(data.errors, (text, line) => ({ line: +line, text })),
          error => error.line
        )
    };
  };
  serializeEdit = tag => {
    return {
      description: tag.name,
      groupId_0: tag.group && tag.group.id,
      categoryId: tag.category && tag.category.id,
      field1: tag.field1,
      field2: tag.field2,
      homeLocation: tag.tagAge,
      trackTagAge: tag.homeLocation
    };
  };
  serializeDelete = tag => {
    return {
      nodeAddress: tag.id,
      siteId: tag.site.id
    };
  };
  serialize = tag => {
    let serializedTag = this.serializeEdit(tag);
    delete serializedTag.groupId_0;
    return {
      ...serializedTag,
      groups: tag.group ? [tag.group.id] : [],
      macAddress: tag.macAddress,
      siteId: tag.site.id
    };
  };
  serializeHistory = result => {
    let d = result.time;
    if(typeof(d) === 'string'){
      d = d.concat('Z')//js needs the z for UTC
    }
    return {
      latitude: result.metadata.props.latitude
        ? +result.metadata.props.latitude
        : undefined,
      longitude: result.metadata.props.longitude
        ? +result.metadata.props.longitude
        : undefined,
      time: parse(d || ''),
      etype: MSG_SOURCE[result.metadata.props.msgType] || 'none'
    };
  };
}

export const TagSerializer = new Serializer();


// WEBPACK FOOTER //
// ./src/models/tag/index.js